// import React, { useEffect, useState } from 'react';
// import './people.css';
// import { Base_Url } from '../config';
// import axios from 'axios';

// const AtAGlimpse = () => {
//   const [allFaculty, setAllFaculty] = useState([]);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get(`${Base_Url}/profiles`);
//       const data = response.data;

//       // Filter people who have show_in_display true AND are retired
//       const filteredData = data.filter(person => 
//         person.show_in_display === 1 && person.isretired === 1
//       );

//       const headPerson = filteredData.filter(person =>
//         person.show_hod === 1
//       );

//       // Get all Sr. System Managers
//       const srSysManagers = filteredData.filter(person =>
//         person.designation === 'Sr. System Manager (SG)'
//       );

//       const systemManagers = filteredData.filter(person =>
//         person.designation === 'System Manager'
//       );

//       const sysArchitects = filteredData.filter(person =>
//         person.designation === 'System Architect'
//       );

//       // All other staff including Sr. Laboratory Asstt.
//       const otherStaff = filteredData.filter(person =>
//         !['System Manager', 'Sr. System Manager (SG)', 'System Architect'].includes(person.designation)
//       );

//       setAllFaculty(otherStaff)

//       // For debugging
//       console.log('Filtered Staff:', otherStaff);
//     } catch (error) {
//       console.error('Error fetching data:', error);
//     }
//   };

//   console.log(allFaculty)
//   return (
//     <div className="at-a-glimpse-container">
//       <h2 className="page-title mb-4 border-bottom-0 mb-0 pb-0">
//         Ex <span className="highlight-title">Staff Members</span>
//       </h2>
//       <hr />
      
//       <div className="at-a-glimpse-table-container">
//         <table className="at-a-glimpse-table">
//           <thead>
//             <tr className="at-a-glimpse-table-header">
//               <th style={{background:"#c21717", color:"#fff"}}>Name</th>
//               <th style={{background:"#c21717", color:"#fff"}}>Designation</th>
//             </tr>
//           </thead>
//           <tbody>
//             {allFaculty.map((person, index) => (
//               <tr key={index}>
//                 <td className="fw-semibold">
//                   {person.name}
//                 </td>
//                 <td className="fw-bold" style={{color:"#c21717"}}>
//                   {person.designation}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default AtAGlimpse;


import React, { useEffect, useState } from 'react';
import { Base_Url } from '../config';
import axios from 'axios';

// CSS styles moved to an external stylesheet
import './people.css';

const AtAGlimpse = () => {
  const [allFaculty, setAllFaculty] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    fetchData();
    
    // Add responsive window resize listener
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    
    // Cleanup on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${Base_Url}/profiles`);
      const data = response.data;
      
      const filteredData = data.filter(person => 
        person.show_in_display === 1 && person.isretired === 1
      );
      
      const otherStaff = filteredData.filter(person =>
        !['System Manager', 'Sr. System Manager (SG)', 'System Architect'].includes(person.designation)
      );
      
      setAllFaculty(otherStaff);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Determine how many names to show per row based on screen width
  const getNamesPerRow = () => {
    if (windowWidth < 576) {
      return 1; // Mobile: 1 name per row
    } else if (windowWidth < 992) {
      return 2; // Tablet/small laptop: 2 names per row
    } else if (windowWidth < 1400) {
      return 3; // Laptop/desktop: 3 names per row
    } else {
      return 5; // Large desktop: 5 names per row
    }
  };

  // Function to chunk array into groups based on screen size
  const chunkArray = (arr) => {
    const size = getNamesPerRow();
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  return (
    <div className="at-a-glimpse-container">
      {/* <h2 className="page-title mb-4 border-bottom-0 mb-0 pb-0 text-center">
        Superannuated / Resigned <span className="highlight-title">Non-Academic</span>
      </h2> */}

       <h2 className="page-title mb-4 border-bottom-0 mb-0 pb-0 text-center">
  Former Non-academic <span className="highlight-title"> Members</span>
</h2>
      <hr />
      
      <div className="at-a-glimpse-table-container">
        <table className="at-a-glimpse-table">
          <thead>
            <tr className="at-a-glimpse-table-header">
              <th>Non-Academic Members</th>
            </tr>
          </thead>
          <tbody>
            {chunkArray(allFaculty).map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>
                  {row.map((person, index) => (
                    <React.Fragment key={index}>
                      <span className="staff-name">{person.name}</span>
                      {index < row.length - 1 && <span className="separator">|</span>}
                    </React.Fragment>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AtAGlimpse;